import '../../modules/mode-components';

import * as angular from 'angular';

import controller from '../interstitial-email-an-admin/email-an-admin-controller';
import template from './modal-email-an-admin.html';

const emailAnAdminDirective = function (Modal) {
  return {
    restrict: 'A',
    scope: {},
    link: function ($scope: angular.IScope, elem) {
      elem.on('click.context', () => {
        Modal.open(
          {},
          {
            controller: controller,
            controllerAs: 'ctrl',
            bindToController: true,
            template: template,
          }
        );
      });

      // cleanup handlers
      $scope.$on('$destroy', () => elem.off('click.context'));
    },
  };
};

emailAnAdminDirective.$inject = ['ModalService'];

angular.module('mode.components').directive('emailAnAdmin', emailAnAdminDirective);
